var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.prvCompetition.name}},[_c('b-card-body',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.intro_message)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }